import React from 'react';
import LandingNavbar from './LandingNavbar';
import ChatBubble from './ChatBubble';

/**
 * PublicPageLayout — wrapper for all public pages.
 * Uses the unified LandingNavbar which handles both logged-in and logged-out state.
 */
const PublicPageLayout = ({ children }) => {
  return (
    <>
      <LandingNavbar />
      {children}
      <ChatBubble />
    </>
  );
};

export default PublicPageLayout;
